// =============================================================
// TOP モーフ演出（先方 SVG「9月公開分」の正パスを vanilla で駆動）
//
// img03 を1枚だけ画面に固定し、SVG clipPath のパスを
// 三角(onigiri) → 円(circle) → 角丸長方形(rect) へモーフする。
//
// 形状は先方 SVG（scene1〜3 / all_scenes）の正パスを採用。すべて
// 1200×800 キャンバス・中心(600,400)・M+C×12+Z のポイントマッチなので、
// flubber を使わず「始点インデックスを合わせた直接点補間」で先方の流れを再現：
//   三角→円 = scene2（三角始点 277,477 → 円始点 383,635）
//   円→角丸 = scene3（円始点 280,400 → 角丸始点 100,400）
// 三角↔円 の遷移だけ、旧動画由来の回転(ROT)＋中間縮小(SHRINK)を
// マスク(clip path)側にのみ重畳（背景 img03 は正立・等倍）。
//
// - 位置/サイズは anchorSpecs（動画実測）の crect にフィットさせて配置。
// - 3層: BG(body) / モーフパス(この固定ステージ) / テキスト(.p-home の各セクション)
// - prefers-reduced-motion / 未対応時は何もしない（＝既存メディア表示のまま）
//
// TODO(次段階): Trusted Experience 以降（四角の中身入れ替え：施設動画→製品グリッド→News）。
// =============================================================

/* ---------- 先方 SVG の正パス（1200×800・中心600,400・ポイントマッチ） ---------- */
const CLIENT_PATHS = {
	// 三角（scene2 版・始点 277.2,477.4）
	triangle: 'M277.2,477.4 C277.2,477.4 300.5,437.0 323.8,396.6 C347.2,356.2 370.5,315.8 370.5,315.8 C370.5,315.8 460.0,160.9 460.0,160.9 C491.1,107.0 545.5,80.0 600.0,80.0 C654.5,80.0 708.9,107.0 740.0,160.9 C740.0,160.9 832.5,320.9 832.5,320.9 C832.5,320.9 855.1,360.1 877.6,399.2 C900.2,438.3 922.8,477.4 922.8,477.4 C985.1,585.2 907.3,720.0 782.8,720.0 C782.8,720.0 691.4,720.0 600.0,720.0 C508.6,720.0 417.2,720.0 417.2,720.0 C292.7,720.0 214.9,585.2 277.2,477.4 Z',
	// 円（scene2 到達形・始点 383.2,635.4）＝三角→円 の TO
	circleIn: 'M383.2,635.4 C319.8,576.9 280.0,493.1 280.0,400.0 C280.0,354.3 289.6,310.8 306.8,271.5 C324.1,232.2 349.0,197.0 379.8,167.8 C437.1,113.4 514.7,80.0 600.0,80.0 C643.8,80.0 685.5,88.8 723.5,104.7 C761.5,120.6 795.8,143.6 824.7,172.1 C883.5,230.2 920.0,310.8 920.0,400.0 C920.0,439.8 912.7,478.0 899.4,513.1 C886.1,548.3 866.8,580.5 842.7,608.5 C784.0,676.8 697.1,720.0 600.0,720.0 C558.2,720.0 518.2,712.0 481.6,697.4 C445.0,682.8 411.7,661.6 383.2,635.4 Z',
	// 円（scene3 開始形・始点 280.0,400.0）＝円→角丸 の FROM（circleIn と同一形・別インデックス）
	circleOut: 'M280.0,400.0 C280.0,354.3 289.6,310.8 306.8,271.5 C324.1,232.2 349.0,197.0 379.8,167.8 C437.1,113.4 514.7,80.0 600.0,80.0 C643.8,80.0 685.5,88.8 723.5,104.7 C761.5,120.6 795.8,143.6 824.7,172.1 C883.5,230.2 920.0,310.8 920.0,400.0 C920.0,439.8 912.7,478.0 899.4,513.1 C886.1,548.3 866.8,580.5 842.7,608.5 C784.0,676.8 697.1,720.0 600.0,720.0 C558.2,720.0 518.2,712.0 481.6,697.4 C445.0,682.8 411.7,661.6 383.2,635.4 C319.8,576.9 280.0,493.1 280.0,400.0 Z',
	// 横長角丸（scene3 到達形・始点 100.0,400.0）
	rect: 'M100.0,400.0 C100.0,400.0 100.0,177.4 100.0,177.4 C100.0,163.4 111.3,152.1 125.3,152.1 C125.3,152.1 600.0,152.1 600.0,152.1 C600.0,152.1 1074.7,152.1 1074.7,152.1 C1088.7,152.1 1100.0,163.4 1100.0,177.4 C1100.0,177.4 1100.0,400.0 1100.0,400.0 C1100.0,400.0 1100.0,622.6 1100.0,622.6 C1100.0,636.6 1088.7,647.9 1074.7,647.9 C1074.7,647.9 607.7,647.9 607.7,647.9 C607.7,647.9 125.3,647.9 125.3,647.9 C111.3,647.9 100.0,636.6 100.0,622.6 C100.0,622.6 100.0,400.0 100.0,400.0 Z',
};

/* ---------- パス ユーティリティ（ポイントマッチ前提） ---------- */
// パスの「実描画 bbox」をベジェのサンプリングで取る（角丸コーナーの膨らみまで含める）。
// ※オンカーブ頂点基準だと三角の角丸膨らみ分を取りこぼし、箱サイズがズレる。
function tightBBox( p ) {
	const t = p.match( /[a-zA-Z]|-?\d*\.?\d+/g ) || [];
	let i = 0, cx = 0, cy = 0, sx = 0, sy = 0;
	let mnx = Infinity, mny = Infinity, mxx = -Infinity, mxy = -Infinity;
	const acc = ( x, y ) => { if ( x < mnx ) mnx = x; if ( x > mxx ) mxx = x; if ( y < mny ) mny = y; if ( y > mxy ) mxy = y; };
	const n = () => parseFloat( t[ i++ ] );
	while ( i < t.length ) {
		const c = t[ i++ ];
		if ( c === 'M' ) { cx = n(); cy = n(); sx = cx; sy = cy; acc( cx, cy ); }
		else if ( c === 'C' ) {
			const x1 = n(), y1 = n(), x2 = n(), y2 = n(), x = n(), y = n();
			for ( let s = 0; s <= 1; s += 0.02 ) {
				const m = 1 - s;
				acc(
					m * m * m * cx + 3 * m * m * s * x1 + 3 * m * s * s * x2 + s * s * s * x,
					m * m * m * cy + 3 * m * m * s * y1 + 3 * m * s * s * y2 + s * s * s * y
				);
			}
			cx = x; cy = y;
		} else if ( c === 'Z' ) { cx = sx; cy = sy; }
	}
	return { minX: mnx, minY: mny, w: mxx - mnx, h: mxy - mny };
}
const CLIENT_BBOX = {
	triangle: tightBBox( CLIENT_PATHS.triangle ),
	circleIn: tightBBox( CLIENT_PATHS.circleIn ),
	circleOut: tightBBox( CLIENT_PATHS.circleOut ),
	rect: tightBBox( CLIENT_PATHS.rect ),
};
// パスを [letter(str) | number] のトークン列にし、各座標を bb → rect へ「箱いっぱい」に写す。
// rect はラベル画像の実寸に固定（三角=628×568 等）＝図形とラベルが同一の箱で一致する。
// （x,y ペアは全コマンド偶数個なので通し番号の偶奇で判定できる）
function fitTokens( p, bb, rect ) {
	const raw = p.match( /[a-zA-Z]|-?\d*\.?\d+/g ) || [];
	const out = [];
	let coord = 0;
	for ( const t of raw ) {
		if ( /[a-zA-Z]/.test( t ) ) { out.push( t ); continue; }
		const v = parseFloat( t );
		if ( coord === 0 ) { out.push( rect.x + ( ( v - bb.minX ) / bb.w ) * rect.w ); coord = 1; }
		else { out.push( rect.y + ( ( v - bb.minY ) / bb.h ) * rect.h ); coord = 0; }
	}
	return out;
}
// トークン列 → d 文字列
function toPath( toks ) {
	let s = '';
	for ( const t of toks ) s += ( s ? ' ' : '' ) + ( typeof t === 'string' ? t : t.toFixed( 2 ) );
	return s;
}
// 2 トークン列を t で補間（同一構造前提：letter は据え置き、number のみ lerp）
function lerpToks( a, b, t ) {
	const out = new Array( a.length );
	for ( let i = 0; i < a.length; i++ ) {
		out[ i ] = typeof a[ i ] === 'string' ? a[ i ] : a[ i ] + ( b[ i ] - a[ i ] ) * t;
	}
	return out;
}

const clamp = ( v, a, b ) => Math.max( a, Math.min( b, v ) );
const lerp = ( a, b, t ) => a + ( b - a ) * t;
const smoothstep = ( a, b, x ) => { const t = clamp( ( x - a ) / ( b - a ), 0, 1 ); return t * t * ( 3 - 2 * t ); };

// 三角↔円 のみ適用する回転・縮小（旧動画由来。ユーザー承認済み）
const ROT = -70;      // 回転ピーク角(deg, 2D 面内)
const SHRINK = 0.34;  // 中間での縮小量（最小 0.66 倍）

export function initWaterStage() {
	const morphEl = document.querySelector( '[data-morph]' );
	const graphic = document.querySelector( '.p-home__morphGraphic' );
	if ( ! morphEl || ! graphic ) return;
	const reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	if ( reduce ) return;
	// morph は 769px 以上で動く。768px 以下（SP）では起動しない
	// （has-water-morph も付けない・移設もしない → 通常の p-home__products をそのまま表示）。
	//
	// 769〜1439px は rem 調整（html の font-size = 16px × Z）で 1440 デザインを縮小して見せる。
	// （2026-10-13 までは CSS zoom。rem 化に伴い、下の「出力時に ×Z」を追加した）
	// 以前は 1440px 以上限定だったが、ノート PC など小さい画面でも図形を出すため下限を下げた。
	if ( ! window.matchMedia( '(min-width: 769px)' ).matches ) return;

	// ---- 座標系について（重要） ----------------------------------------
	// 図形の箱は固定px（1440 デザインの実寸: 三角628×568 / 円672×672 / 四角1358×673）。
	// そこで clip の座標系を「デザイン空間」= 実ビューポート ÷ Z で組む。
	//   Z = min(1, vw/1440, vh/(ヘッダー高+48+673)) を theme.js が --fhps-zoom に書く。
	//   Z = vw/1440 のときデザイン空間の幅は常に 1440 になり、1440 の設計がそのまま通る。
	// Z=1（1440×800 以上）のときは全ての計算が従来と完全に同値になる。
	//
	// getBoundingClientRect() は「描画後の実px」を返す。
	// 幾何に使う値は rectZ() / ÷Z でデザイン空間へ変換する。
	//
	// ★ rem 化（2026-10-13）で変わった点: zoom が無いので、要素に書き込む px・
	//   getComputedStyle で読む px はどちらも「実px」になった。
	//   - 書き込み: デザイン空間の値を zpx() で ×Z して書く
	//   - 読み取り: getComputedStyle の px も ÷Z してデザイン空間へ
	//   - clip（userSpaceOnUse）は当てた要素の CSS px が単位なので、clipPath に scale(Z) を掛ける
	// ただし「スクロール進捗」の計算だけは実スクロールpx空間なので変換しない
	// （scrollY が実px なので、混ぜると進捗がズレる）。
	// --------------------------------------------------------------------
	const zoomFactor = () => {
		const v = parseFloat(
			getComputedStyle( document.documentElement ).getPropertyValue( '--fhps-zoom' )
		);
		return v > 0 ? v : 1;
	};

	// morph 対象の形状列（三角→円→角丸長方形）
	const shapeSeq = [ 'onigiri', 'circle', 'rect' ];

	// 固定ステージ DOM を生成
	const stage = document.createElement( 'div' );
	stage.className = 'p-home__waterStage';
	stage.setAttribute( 'aria-hidden', 'true' );
	const svgNS = 'http://www.w3.org/2000/svg';
	const svg = document.createElementNS( svgNS, 'svg' );
	svg.setAttribute( 'class', 'p-home__waterClip' );
	const defsEl = document.createElementNS( svgNS, 'defs' );
	const clip = document.createElementNS( svgNS, 'clipPath' );
	const clipId = 'p-home-water-clip';
	clip.setAttribute( 'id', clipId );
	clip.setAttribute( 'clipPathUnits', 'userSpaceOnUse' );
	const path = document.createElementNS( svgNS, 'path' );
	path.setAttribute( 'd', 'M0 0Z' );
	clip.appendChild( path );
	defsEl.appendChild( clip );
	svg.appendChild( defsEl );
	stage.appendChild( svg );
	const water = document.createElement( 'div' );
	water.className = 'p-home__waterFill';
	water.style.clipPath = `url(#${ clipId })`;
	water.style.webkitClipPath = `url(#${ clipId })`;
	stage.appendChild( water );

	// ラベル層（透過素材待ち・暫定 pc_img01/02）
	const cssVars = getComputedStyle( graphic );
	const labelEls = shapeSeq.map( ( sh, i ) => {
		const url = cssVars.getPropertyValue( `--fhps-label-${ i }` ).trim();
		if ( ! url || url === 'none' ) return null;
		const el = document.createElement( 'div' );
		el.className = 'p-home__waterLabel';
		el.style.backgroundImage = url;
		el.style.clipPath = `url(#${ clipId })`;
		el.style.webkitClipPath = `url(#${ clipId })`;
		stage.appendChild( el );
		return el;
	} );

	graphic.appendChild( stage );
	document.documentElement.classList.add( 'has-water-morph' );

	// Experience マスク：固定水rect窓＝experienceWindow(position:sticky + overflow:hidden)。
	// 動画＋テキスト全体(experienceInner)を translateY で「通常フロー位置」へ動かし、窓を通過＝ネイティブにマスク。
	// 動画本体は rect 完成後に opacity クロスフェード。
	const expScroll = document.querySelector( '.p-home__experienceScroll' );
	const expWindow = document.querySelector( '.p-home__experienceWindow' );
	const expInner = document.querySelector( '.p-home__experienceInner' );
	const mediaFigure = document.querySelector( '.p-home__experienceMovie' );
	const expBody = document.querySelector( '.p-home__experienceBody' );
	if ( mediaFigure ) mediaFigure.style.opacity = '0';
	if ( expBody ) expBody.style.opacity = '0';

	// アンカー rect（動画の確定フレームから実測。位置・サイズを決める）
	// Products & Solutions morph（第4ストップ／セクション位置駆動 = 既存3ストップの sp とは独立）。
	// Experience 全幅rect → productsBg の左メディア箱へ「右から縮む」（動画 f_0349→f_0366）。
	// sp/STOPS には触れず、pp（productsMedia の画面中央到達度 0..1）で駆動する。
	const productsSection = document.querySelector( '[data-products-morph]' );
	const productsMedia = productsSection ? productsSection.querySelector( '.p-home__productsMedia' ) : null;
	const productsSliderEl = productsSection ? productsSection.querySelector( '.p-home__productsSlider' ) : null;

	// Products 着地の縦位置（デザイン空間の画面Y。メディア箱＝水rectの着地先の中心）。
	// 2026-08-27（指摘 10 回目）: 従来は vh/2（画面の縦中央）だった。productsMedia は
	// aspect-ratio 717/618・max-height 618px なので高さ 618px あり、縦中央に置くと上端が
	//   1366×768（vh_design 791）: 791/2 − 309 = 86.5px  → ヘッダー(70px)の 16.5px 下
	// になり「右テキストと揃うタイミングがヘッダーギリギリ」になる。48px 下げる。
	// 下端が画面外に近づかないよう vh − 24 − h/2 でクランプ（vh_design は Z の式より常に 791 以上）。
	//   1366×768 での変更後: 上端 134.5px（ヘッダーの 64.5px 下）／下端 752.5px（画面下 38.5px）
	// ※この値は 4 箇所（pp の終端 / toBox.y / followY / rebuild の sy）で共有する必要がある。
	//   1 箇所だけ変えると「水rect の着地先」と「実メディアの位置」がズレる。
	const PRODUCTS_LAND_SHIFT = 48;
	const PRODUCTS_SWEEP = 0.85;   // 掃引の尺（vh 比）。2026-08-27: 0.70 → 0.85。テキスト群が抜けてから
	                               // 掃引が始まるまでの「四角だけ」の区間を 225px → 106px に詰めるため開始を前倒し。
	                               // 尺は 567 → 672px（+19%）。以前の「移動をゆっくりに」の指摘とも同方向。
	const productsLandCenter = ( h ) => Math.min( vh / 2 + PRODUCTS_LAND_SHIFT, vh - 24 - h / 2 );
	// テキストは CSS 側で下からスライドアップ（.is-products-revealed）。productsMedia は水rectの入力
	// (getBoundingClientRect)源として空箱のまま温存する。
	// スライダーは「水ステージ」に載せてロックする：水rect と同じ stage の子（＝同一 transform に乗る）にし、
	// morph shape でクリップ。専用の per-frame 補正はせず、水rect の動きにそのまま追従＝ふわつき無し・必ず一致。
	// 位置/サイズは rebuild で設定、出現(opacity)は render でクラス付与。
	let productsLayer = null;
	if ( productsSliderEl ) {
		productsLayer = document.createElement( 'div' );
		productsLayer.className = 'p-home__productsLayer';
		productsLayer.style.clipPath = `url(#${ clipId })`;
		productsLayer.style.webkitClipPath = `url(#${ clipId })`;
		productsLayer.appendChild( productsSliderEl );   // splide DOM ごと移設（インスタンスは維持）
		// 基底CSS（絶対配置・SPの translate(-50%) 等）を打ち消し、層内で JS 指定の箱に置く。
		productsSliderEl.style.position = 'absolute';
		productsSliderEl.style.transform = 'none';
		productsSliderEl.style.margin = '0';
		productsSliderEl.style.right = 'auto';
		stage.appendChild( productsLayer );
	}

	// vw / vh はデザイン空間（実ビューポート ÷ Z）。Z=1 のとき従来と完全に同値。
	let anchors = [], segs = [], vw = 0, vh = 0, spSpan = 0, Z = 1;
	// デザイン空間の長さ → 要素に書く実px（rem 化で zoom が無くなったため ×Z が必要）
	const zpx = ( v, digits = 1 ) => ( v * Z ).toFixed( digits ) + 'px';
	// 要素の矩形をデザイン空間で取る。幾何の比較・配置はすべてこちらを使う。
	const rectZ = ( el ) => {
		const r = el.getBoundingClientRect();
		return {
			top: r.top / Z, left: r.left / Z, right: r.right / Z,
			bottom: r.bottom / Z, width: r.width / Z, height: r.height / Z,
		};
	};
	function anchorSpecs() {
		const MAXW = 1440, PAD = 40;
		const colW = Math.min( vw, MAXW ) - PAD * 2;
		const colLeft = ( vw - Math.min( vw, MAXW ) ) / 2 + PAD;
		const headerEl = document.querySelector( '.o-globalHeader' );
		// ヘッダーがあれば実測値を使うので高さ変更に自動追従する。
		// フォールバックは PC ヘッダーの実装値 (70px) に合わせる。
		// ヘッダーは body ごと zoom されるので、必要なのはデザイン空間の高さ（= CSS 上の 70 / 60）。
		// getBoundingClientRect は必ず描画値なので ÷Z で戻す。
		// offsetHeight は zoom 配下でレイアウト値か描画値かがブラウザ実装依存なので使わない。
		const headH = headerEl ? headerEl.getBoundingClientRect().height / Z : 70;
		const safeTop = headH + 12;   // デザイン空間で 12px（描画では 12×Z）
		// サイズは固定px（ラベル画像/img03 の実寸）。位置は cxC=カラム内中心比のみ。
		// 3 形状とも「ヘッダー高を除いた領域（vh − headH）の縦中央」に置く。
		//
		// ※これは動画実測から離れる変更で、デザイン根拠ではなくユーザー指示による。
		//   旧規則: `y = Math.max( cyF * vh - h / 2, safeTop + extraTop )`
		//           cyF は 三角 0.51 / 円 0.47 / 四角 0.47、四角のみ extraTop = 48。
		//   旧規則の問題:
		//     - 円は cyF=0.47 だと y = 0.47×800 − 336 = 40px でヘッダー(70px)に潜るため、
		//       従来も safeTop クランプで 82px に押し下げられていた
		//       ＝1440×800 の時点で動画実測どおりの位置になっていなかった
		//     - 四角は上に 130px・下に 0px の非対称で、画面下端に接していた
		//   「ヘッダー下領域の中央」に統一すると挙動が明示的で、画面が低い環境でも一貫する。
		//
		// safeTop クランプはガードとして残す。theme.js の Z が
		//   Z ≤ ( vh − headerH − 12 ) / 673
		// を満たすので、デザイン空間で「safeTop + 673 ≤ vh」が保証される。
		// ＝高さが厳しい環境ではクランプが効いて上詰め＋下端ぴったり、余裕があれば中央。
		// どちらの場合も 3 形状（568 / 672 / 673）とも画面内に収まる。
		const atMid = ( cxC, wPx, hPx ) => {
			const w = wPx, h = hPx;
			const y = Math.max( ( vh + headH - h ) / 2, safeTop );
			return { x: colLeft + cxC * colW - w / 2, y, w, h };
		};
		return [
			{ shape: 'onigiri', rect: atMid( 0.786, 628, 568 ) },          // Mission  pc_img01
			{ shape: 'circle', rect: atMid( 0.246, 672, 672 ) },           // Performance pc_img02（672=img03 の高さ673px に収まる最大値）
			// 四角の y は expWindow.style.top に渡って Experience の動画マスクのピン位置も決める。
			// 窓が四角に追従し、フェード閾値も同じ anchors[2].rect を見るので整合は保たれる。
			{ shape: 'rect', rect: atMid( 0.50, 1358, 673 ) },             // Experience img03 全幅
		];
	}
	// crect = その形状を画面中央に置いた rect。offset = 実際の休止位置への平行移動量。
	function crectOf( a ) {
		return { x: vw / 2 - a.rect.w / 2, y: vh / 2 - a.rect.h / 2, w: a.rect.w, h: a.rect.h };
	}
	function rebuild() {
		// vw は clip 座標(SVG viewBox)＝要素の box 幅に合わせる。window.innerWidth は縦スクロールバーを含み
		// CSS の background-position:center（要素幅基準）と半スクロールバー分ズレるため clientWidth を使う。
		Z = zoomFactor();
		vw = document.documentElement.clientWidth / Z; vh = window.innerHeight / Z;
		svg.setAttribute( 'viewBox', `0 0 ${ vw } ${ vh }` );
		// パスはデザイン空間で組むので、clip の座標（＝当てた要素の実px）へ ×Z で写す。
		// path 自身の transform（三角↔円の回転・縮小）はこの内側で効く。
		clip.setAttribute( 'transform', `scale(${ Z })` );
		anchors = anchorSpecs();
		anchors.forEach( ( a ) => {
			a.crect = crectOf( a );
			a.offset = { x: ( a.rect.x + a.rect.w / 2 ) - vw / 2, y: ( a.rect.y + a.rect.h / 2 ) - vh / 2 };
		} );
		// 各セグメントの from/to を crect にフィットしてトークン化（先方の始点インデックスを維持）
		segs = [
			{
				from: anchors[ 0 ], to: anchors[ 1 ],
				fromToks: fitTokens( CLIENT_PATHS.triangle, CLIENT_BBOX.triangle, anchors[ 0 ].crect ),
				toToks: fitTokens( CLIENT_PATHS.circleIn, CLIENT_BBOX.circleIn, anchors[ 1 ].crect ),
			},
			{
				from: anchors[ 1 ], to: anchors[ 2 ],
				fromToks: fitTokens( CLIENT_PATHS.circleOut, CLIENT_BBOX.circleOut, anchors[ 1 ].crect ),
				toToks: fitTokens( CLIENT_PATHS.rect, CLIENT_BBOX.rect, anchors[ 2 ].crect ),
			},
		];
		path.setAttribute( 'd', toPath( segs[ 0 ].fromToks ) );
		// ラベルは図形と同一の箱（crect＝固定px＝ラベル実寸）に合わせる。位置は CSS の center。
		labelEls.forEach( ( el, i ) => {
			if ( ! el ) return;
			const r = anchors[ i ].crect;
			el.style.backgroundSize = `${ zpx( r.w ) } ${ zpx( r.h ) }`;
		} );
		// Experience 窓（sticky）のピン位置を水rectの画面Yへ。
		if ( expWindow ) expWindow.style.top = zpx( anchors[ 2 ].rect.y );
		// Products スライダー層：着地時の左メディア箱（画面座標）を stage ローカル(− offset)へ絶対配置。
		// 層は inset:0（clip 用）で stage transform に乗るため、内側 slider を箱に置く＝水rectと同じ動きにロック。
		if ( productsLayer && productsMedia ) {
			const pm = rectZ( productsMedia );
			const poff = anchors[ 2 ].offset;
			// スライダーは写真の 3:2 を維持（メディア箱高に引き伸ばさない）。縦中央。
			// 2026-10-23: 幅を箱幅いっぱい → Figma 1:122 の配置に変更
			//   下敷き 717×618 の中にスライダー 600×400（left 41 / top 109 = 縦中央）。比率で書く
			const sw = pm.width * 600 / 717;
			const sh = sw * 2 / 3;
			const sy = productsLandCenter( pm.height ) - sh / 2;   // 3:2 箱を着地中心に置いた時の上端
			productsSliderEl.style.left = zpx( pm.left + pm.width * 41 / 717 - poff.x );
			productsSliderEl.style.top = zpx( sy - poff.y );
			productsSliderEl.style.width = zpx( sw );
			productsSliderEl.style.height = zpx( sh );
		}

		// sp の分母を「morph 先頭 → Products セクション開始」に固定する（＝Experience までの区間）。
		// Products を data-morph 内へ入れて pin を延長しても、この span は変わらないので既存3ストップの
		// sp（=STOPS の位置）は不変。Products の morph は別途 pp（下）で駆動する。
		// Experience の入場タイミング合わせも兼ねる（内部で spSpan を確定する）。
		if ( expScroll && expInner && anchors[ 2 ] ) {
			fitExperienceEntry();
		} else {
			spSpan = measureSpSpan().span;
		}
	}

	// スクロール進捗の分母。rect も scrollY も実px なので、ここは実スクロールpx空間で計算する
	// （vh = デザイン空間 を混ぜると進捗がズレる）。Z=1 なら従来と同値。
	function measureSpSpan() {
		const morphTopDoc = morphEl.getBoundingClientRect().top + window.scrollY;
		if ( productsSection ) {
			const prodTopDoc = productsSection.getBoundingClientRect().top + window.scrollY;
			return {
				morphTopDoc,
				span: Math.max( 1, ( prodTopDoc - morphTopDoc ) - window.innerHeight ),
			};
		}
		return {
			morphTopDoc,
			span: Math.max( 1, morphEl.offsetHeight - window.innerHeight ),
		};
	}

	// _front.scss の既定値。ここを変えたら CSS 側も合わせる。
	const EXP_GUTTER_BASE = 673;    // &__experienceInner の padding-top（＝窓の高さ）

	// Experience の中身（動画＋テキスト）は sticky 窓 + overflow:hidden のネイティブマスクで
	// 通過する。窓の pin 範囲より通過距離が長いと、通過し終わる前に pin が切れて窓ごと画面上へ
	// ずれる ＝ 中身が水rectの外（ヘッダーの上まで）に出る／テキストが窓の外へ落ちて消える。
	//
	// 2026-08-27 の不具合はこれ。実測値:
	//   窓の inline top 103.8px に対し実際の top が −164px（＝pin が 164px 切れていた）
	//   pin 範囲 2289.2 − 673 = 1616px ／ 中身が入る前に 1089px 消費 ／ 通過に 1627px 必要
	//
	// pin 範囲と通過距離の関係（すべてデザイン空間px。H = expScroll の高さ）:
	//   入場する位置     sTop = 窓のtop + 窓の高さ − ガーター
	//   pin が切れる位置 sTop = 窓のtop − ( H − 窓の高さ )
	//   ＝ 入場から pin 切れまでの距離 = H − ガーター
	// よって成立条件は「H = ガーター + 通過距離」。通過距離 = 窓の高さ + 中身の高さ。
	//
	// なお「入場を四角の完成に合わせる」（ガーターを逆算して遅らせる）実装は破棄した。
	// 四角の完成位置 spRect ≈ 0.87 は spSpan の中にあり、spSpan には expScroll 自身が
	// 含まれる。ガーターを増やす→H が伸びる→spSpan が伸びる→完成が後ろへ動く、の循環で
	// 増幅率 1/(1−0.87) ≈ 7.4 倍。閉形式で解くと H ≈ 10,473px になり実用にならない。
	// 完成前の露出は opacity のゲート（rectGate）側で抑える。
	function fitExperienceEntry() {
		// 768px 以下は morph が動かない帯（CSS がガーターを 0 に戻す）。インラインを残さない。
		// 判定は CSS の @media と同じ基準（スクロールバー込みの幅）。clientWidth だと Windows の 769〜785px でズレる。
		if ( ! window.matchMedia( '(min-width: 769px)' ).matches ) {
			expInner.style.paddingTop = '';
			expScroll.style.height = '';
			spSpan = measureSpSpan().span;
			return;
		}
		// 中身の高さ = expInner の高さ − 今の padding-top。
		// getComputedStyle の px も rect も実px（rem 化で zoom が無くなった）なので両方 ÷Z。
		const padNow = ( parseFloat( getComputedStyle( expInner ).paddingTop ) || 0 ) / Z;
		const contentH = expInner.getBoundingClientRect().height / Z - padNow;
		const gutter = EXP_GUTTER_BASE;
		const travel = anchors[ 2 ].rect.h + contentH;
		expInner.style.paddingTop = zpx( gutter );
		// ガーター = 窓の高さ なので、中身は pin 開始と同時に窓の下端から入り、
		// pin が切れる瞬間に上端へ抜け切る（ちょうど収まる）。
		expScroll.style.height = zpx( gutter + travel );
		// 高さを変えたのでドキュメント高が変わる。spSpan を再測定して確定させる。
		spSpan = measureSpSpan().span;
	}

	// morph コンテナの pin 進捗 sp(0..1)。分母は spSpan（Products 開始まで）に固定。
	function readSp() {
		const r = morphEl.getBoundingClientRect();
		return spSpan > 0 ? clamp( -r.top / spSpan, 0, 1 ) : 0;
	}
	// 2026-08-27: 0.12 → 0.08 → 0.06。三角→円 の遷移開始をさらに手前へ（指摘による）。
	// spToFi は sp <= STOPS[0] で fi=0 を返す（＝形が動かない）ので、遷移開始は
	// STOPS[0] より手前には出せない。開始位置を早めるにはこの値を下げる必要がある。
	// ※STOPS 配列の 1 要素の値だけの変更（incidents.md「作り替えは厳禁」）。
	const LEAD = 0.0717; // FV後の導入区間（＝三角が静止している区間）
	// 各モーフストップの pin 進捗 sp。三角=LEAD / 円=0.52 / 四角=0.80（以降 experience 区間で rect 保持）。
	// 円=0.56→0.52: 円のホールドを詰めて「円→四角」の遷移開始を約2スクロール手前に早める。
	// 四角(0.80)は動かさないので、遷移の終わり（morphT 完了 lt=0.92 → sp≈0.778。変更前 0.781）は
	// ほぼ同位置に留まる＝Experience 側のタイミングに影響しない。
	// 2026-08-27: 3 番目のみ 0.80 → 0.90。
	// experienceScroll を 2400 → 1200 に縮めて spSpan が減った結果、0.80 の指す絶対位置が
	// Experience セクションの開始より手前に来てしまう（＝Experience に入る前に四角が完成する）。
	// 四角の完成を Experience の開始に合わせ直すための再整合。
	// ※配列の 1 要素の値だけを変更（incidents.md「作り替えは厳禁」）。
	// 2026-08-27: 2 番目のみ 0.52 → 0.47。円→四角 の遷移開始を前倒し（指摘による）。
	// 三角側（LEAD 0.06）が「Performance のボタンが画面 Y 322 で開始」になったので、
	// 円側も同じ体感に合わせた値。四角の完成は STOPS[2]=0.90（Experience の開始に整合）
	// のままなので、遷移の終点は動かず開始だけが手前に来る。
	// 2026-08-27（指摘 3 回目）: 2 番目 0.47 → 0.38 / 3 番目 0.90 → 0.62。
	//   指摘 a「円→四角の遷移開始をもっと前倒し」→ 2 番目を下げる（区間1の開始 = STOPS[1]）。
	//   指摘 b「円→四角の遷移自体の必要スクロール量も減らす」→ 3 番目を下げて区間幅を詰める。
	//     遷移長 = 0.87 *（STOPS[2] − STOPS[1]）なので 0.374 → 0.209（−44%）。
	//   併せて 3 番目を下げられるようになった理由: Experience の入場が「四角の完成に合わせる
	//   ガーター逆算」から「pin 開始 = expScroll の上端」に変わった（fitExperienceEntry 参照）。
	//   ＝四角は Experience の開始より手前で完成していなければならない。0.80 → 0.90 に上げた
	//   当時の前提（完成を Experience の開始に一致させる）は成立しなくなったので戻す方向。
	// 変更後の sp（morphT の 0.05/0.52/0.92 は動画実測なので不変）:
	//   三角→円  開始 0.076 / 完成 0.226（変更前 0.081 / 0.273）
	//   円ホールド 0.226 → 0.392（変更前 0.273 → 0.492）
	//   円→四角  開始 0.392 / 完成 0.601（変更前 0.492 / 0.866）
	// ※三角→円 も STOPS[1] を下げた副作用で約 0.047（≒290px）手前で完成する。
	// 2026-08-27（指摘 4 回目）: 3 番目のみ 0.62 → 0.56。
	//   「円から四角へ広がるモーフィング自体をもう少し早く」＝遷移が食うスクロール量を減らす。
	//   遷移長 = 0.87 *（STOPS[2] − STOPS[1]）= 0.209 → 0.157（−25%）。
	//   開始は STOPS[1] + 0.05 *（STOPS[2] − STOPS[1]）なので 0.392 → 0.389 でほぼ動かない
	//   ＝「タイミングは良くなった」状態を保ったまま遷移だけ速くなる。
	//   三角→円（区間0 = [LEAD, STOPS[1]]）は STOPS[1] を触らないので不変。
	// ※morphT の 0.05 / 0.52 / 0.92 は動画実測なので変えない。速度はここでは調整しない。
	// ※配列の 1 要素の値だけを変更（incidents.md「作り替えは厳禁」）。
	// 2026-08-27（指摘 5 回目）: 2 番目 0.38 → 0.50 / 3 番目 0.56 → 0.62。
	//   指示「変形自体を早く短くする」＋「四角に完全に切り替わってすぐに中身が下から出る」。
	//
	//   四角の完成位置 spRect = STOPS[1] + 0.92 *（STOPS[2] − STOPS[1]）＝ 0.92*STOPS[2] + 0.08*STOPS[1]
	//   なので、遷移を短くする（STOPS[2] を下げる）だけでは完成位置が手前へ動いて
	//   「空の四角」が伸びる（0.62 → 0.56 で実際に伸びた）。
	//   遷移長 = 0.87 *（STOPS[2] − STOPS[1]）を短くしつつ完成位置を Experience の開始
	//   （= expScroll の上端。pin 開始 ≒ sp 0.64）へ寄せるには、2 番目と 3 番目を
	//   同時に上げて区間幅だけ詰める必要がある。
	//     遷移長 0.157 → 0.104（−33%）／完成 0.546 → 0.610／空の四角 約460px → 約120px
	//
	//   区間0 =[LEAD, STOPS[1]] が 0.32 → 0.44 に広がるので、区間0 で正規化している定数を
	//   同じ比（1.375）で詰めて 三角→円 の挙動を変えない（＝承認済みの動きを維持）:
	//     morphT 非rect側の完了   0.52 → 0.378   （完成 sp 0.226 を維持）
	//     円ラベルのゲート 0.50/0.54 → 0.364/0.393（morphT の完了と対で動かす）
	//   ※上記 2 つは「動画実測」とコメントしてきた値だが、実測なのは動きそのもので、
	//     区間幅が変われば同じ動きを保つために正規化値は変える必要がある。
	// ※三角ラベルの fade out（1 - smoothstep(0, 0.08, lt)）は区間0/1 で共有のため未調整。
	//   区間0 が広がったぶん 112px → 153px と約 40px 長くなる。
	// 2026-08-27（指摘 6 回目）: 全体のスクロール量を保存する方向が誤りだったので改めた。
	//   間延びの実体は「Performance のテキストが抜けてから Experience の中身が出るまで 780px」で、
	//   その 530px は .p-home__performance の min-height:169vh の余りだった（_front.scss 参照）。
	//   169vh → 840px に縮めて全体を 5216 → 4686px（−530px）にし、そのうえで STOPS を再配置する。
	//
	//   再配置の狙い（morph 先頭からの絶対px。spSpan は 4405 → 3875 に縮む）:
	//     Performance のテキストが抜ける : 1964px
	//     円→四角 開始                  : 1864px（テキスト退出の 100px 前）
	//     円→四角 完成                  : 2214px ＝ 中身の入場（pin 開始）
	//     モーフ長                      : 350px（変更前 455px）
	//   → 2 番目/3 番目 = 開始と完成を上の絶対位置に割り当てた値:
	//        完成 = STOPS[1] + 0.92 *（STOPS[2] − STOPS[1]）= 2214/3875 = 0.5714
	//        開始 = STOPS[1] + 0.05 *（STOPS[2] − STOPS[1]）= 1864/3875 = 0.4810
	//
	//   spSpan が縮むと同じ分数がより手前の絶対位置を指すので、三角→円 の絶対位置を維持するため
	//   LEAD と区間0 で正規化している定数を割り戻す（＝承認済みの 三角→円 は不変）:
	//     LEAD               0.06  → 0.0681 （三角の静止終わり 264px を維持）
	//     morphT 非rect側    0.05  → 0.0615 （三角→円 開始 361px を維持）
	//                        0.378 → 0.4638 （三角→円 完成 997px を維持）
	//     円ラベルのゲート   0.364/0.393 → 0.4461/0.4815（morphT の完了と対）
	//     ラベル fade out    0.08  → 0.098  （三角ラベルの 155px を維持）
	const STOPS = [ LEAD, 0.462, 0.614 ];
	function spToFi( sp ) {
		if ( sp <= STOPS[ 0 ] ) return 0;
		for ( let i = 0; i < STOPS.length - 1; i++ ) {
			if ( sp <= STOPS[ i + 1 ] ) return i + ( sp - STOPS[ i ] ) / ( STOPS[ i + 1 ] - STOPS[ i ] );
		}
		return STOPS.length - 1; // rect を保持
	}

	// 円ラベル(Performance)の fade in 判定に使うテキスト。位置基準で駆動するため参照を持つ。
	const perfText = document.querySelector( '.p-home__performance .p-home__sectionText' );

	// entering ラベルの fade in。
	// 円(m=1)のみ位置基準：テキスト中心が「円の下端 → 円の中心」に上がる間に 0→1。
	//   動画根拠 f_0135(円成立・ラベル無し) → f_0149(半透明・テキスト中央やや下) → f_0161(ほぼ不透明・
	//   テキストが円の中心) → f_0173(不透明)。＝テキストのせり上がりに同期し、円の中心に並ぶ時点では出ている。
	//   morph 進捗基準（旧 smoothstep(0.74,0.92,lt)）ではテキストの中央到達に間に合わなかった。
	// 円が出来る前に出ないよう、形状 morph の完了(lt 0.50→0.54。morphT は 0.52 で完了)でゲートする。
	// テキストが中心に来るのが早すぎてゲートに間に合わない場合は、この2値と morphT の 0.52 を同時に下げる。
	function enterOpacity( m, lt ) {
		if ( m !== 1 || ! perfText || ! anchors[ 1 ] ) return smoothstep( 0.74, 0.92, lt );
		const cr = anchors[ 1 ].rect;
		const r = rectZ( perfText );          // cr がデザイン空間なので rect も揃える
		const c = r.top + r.height / 2;
		return smoothstep( cr.y + cr.h, cr.y + cr.h * 0.5, c ) * smoothstep( 0.4906, 0.5296, lt );
	}

	// 三角ラベル（m=0）の出現を「graphic が位置固定される直前」に合わせる。
	//
	// 2026-08-27 の指摘: テキストの入りを早めた（padding-top を 90vh → 40px）ので、
	// ラベルの出現が相対的に遅く見える。
	//
	// 旧: `smoothstep( 0.35 * LEAD, 0.9 * LEAD, sp )` ＝ sp 0.042〜0.108 でフェードイン。
	//     sp は readSp() が 0 でクランプするため **pin する瞬間に 0**。つまり旧実装は
	//     「pin してから 130〜350px スクロールした後」に出ていた。
	// 新: pin までの残り距離（graphic の画面Y）で駆動する。pin 前から効くので
	//     「位置固定の直前にフェードイン完了」になる。
	const LABEL0_PIN_LEAD = 300;   // pin まで残りこの距離（デザインpx）からフェードイン開始

	// ラベル opacity：ストップ hold で 1、morph 開始前に out・完了後に in
	// pinIn = 三角ラベル用の pin 接近度（0→1）。render が 1 フレーム 1 回だけ計測して渡す。
	function labelOpacity( m, fi, pinIn ) {
		const nSeg = segs.length;
		const seg = clamp( Math.floor( fi ), 0, nSeg - 1 );
		const lt = clamp( fi - seg, 0, 1 );
		let op = 0;
		// 2026-08-27: 退出を 0.10〜0.28 → **0〜0.08** に。
		// morphT の下限を 0.05 に前倒ししたため、旧値だと形が 48% ほど変形した時点まで
		// ラベルが残っていた（指摘「モーフィング時に少し残ってしまっている」）。
		// lt=0 では 1 のままなので、ストップで静止している間の表示は変わらない。
		// ※三角ラベルだけでなく円ラベルの退出にも同じ式が効く（原因が同じなので揃えている）。
		// 2026-08-27（指摘 9 回目）: 155px → 87px。三角→円 の遷移開始を 361 → 293px に前倒し
		// したので、ラベルがモーフに食い込む量を従来と同じ約 59px に保つため同じだけ詰める。
		// ※この定数は区間0/1 共有。区間1（円ラベル）側は 60px → 34px と速くなる。
		if ( m === seg ) op = 1 - smoothstep( 0, 0.061, lt );
		else if ( m === seg + 1 ) op = enterOpacity( m, lt );
		if ( m === 0 ) op *= pinIn;
		return op;
	}

	let smooth = 0;
	let smoothScroll = 0;   // スクロール位置の平滑値。Products の水rect上昇を段階的にしないための追従基準。
	function render( sp ) {
		const nSeg = segs.length;
		const fi = clamp( spToFi( sp ), 0, nSeg );
		const seg = clamp( Math.floor( fi ), 0, nSeg - 1 );
		const lt = clamp( fi - seg, 0, 1 );
		const s = segs[ seg ];
		// 区間ごとの morph 窓。円→四角は「円のまま中央へ移動 → その後に膨張」で後半寄せ。
		// 三角→円は 0.30 開始（三角ラベルが lt 0.28 で消え切った後）／0.52 完了。
		// 完了を前倒しするのは、円が出来てから Performance テキストがせり上がって中心に並ぶまでの
		// 「ホールド」を確保するため（動画 f_0135 で円は完成・左定位置・強ブラー、テキストは画面最下部）。
		// ブラーは lt 基準なので円の完成後も残り、lt→1 で晴れる（動画 f_0149→0161 と一致）。
		const toRect = s.to.shape === 'rect';
		// 2026-08-27（指摘 7 回目）: 区間1（円→四角）の内訳を組み替えた。
		//   指摘 a「中央に移動して広がり始める部分が急すぎる」→ posT を 0.50 → 0.57 に伸ばす。
		//   指摘 b「広がりつつ四角になるのが少し時間が長い」→ morphT の下限を 0.05 → 0.38 に上げる。
		//   指摘 c「円の遷移開始を早める」→ STOPS[1] 0.476 → 0.439（区間の頭＝移動の開始）。
		//   区間1 は 403px → 558px に広がるが、完成位置は 2214px（中身の入場）に固定したまま。
		//     移動   1701 → 2019px（318px。変更前 201px）
		//     形状   1913 → 2214px（301px。変更前 349px）
		//   非rect側（三角→円）は区間0 の幅が変わったぶん割り戻して絶対位置を維持:
		//     0.0615 → 0.0676（開始 361px）／0.4638 → 0.5101（完成 997px）
		//   2026-08-27（指摘 9 回目）: 非rect側の下限 0.0676 → 0.02。
		//   「各モーフの動き方が違うのは了解。三角側の遷移開始を少し早めて」への対応。
		//   三角→円 の開始 361px → 293px（−68px）。完成 997px は動かさないので尺は 636 → 704px。
		//   下限 0 まで下げると LEAD（264px = 三角の静止終わり）に一致してそこが下限。
		const morphT = toRect ? smoothstep( 0.38, 0.92, lt ) : smoothstep( 0.02, 0.5101, lt );

		// 形状/サイズ（中央固定）: 先方パスの直接点補間。
		path.setAttribute( 'd', toPath( lerpToks( s.fromToks, s.toToks, morphT ) ) );

		// ブラーは遷移中ずっと。lt 基準で両端0・中央ピーク。
		const blur = 2.5 * Math.sin( Math.PI * lt );
		water.style.filter = blur > 0.1 ? `blur(${ zpx( blur, 2 ) })` : 'none';

		// 三角/円/四角は clip が stage 中央に固定され stage ごと平行移動するため、水は常に中央でよい。
		// （Products 区間だけは下で背景位置をクリップ箱へ追従させる）
		water.style.backgroundPosition = 'center';

		// 位置（translate）。円→四角は位置を morph 前(0.50)に完了。三角→円は morphT 基準で位置が先行。
		const posT = toRect ? smoothstep( 0, 0.57, lt ) : smoothstep( 0, 0.7, morphT );
		const tx = lerp( s.from.offset.x, s.to.offset.x, posT );
		const ty = lerp( s.from.offset.y, s.to.offset.y, posT );

		// 三角↔円 の遷移中だけ「回転＋中間で縮小」。両端0・中央ピーク。
		let rot = 0, scl = 1;
		const triCircle =
			( s.from.shape === 'onigiri' && s.to.shape === 'circle' ) ||
			( s.from.shape === 'circle' && s.to.shape === 'onigiri' );
		if ( triCircle ) {
			const k = Math.sin( Math.PI * morphT );
			rot = ROT * k;
			scl = 1 - SHRINK * k;
		}

		// 回転・縮小は「マスク(clip path)だけ」に適用（背景 img03 は正立・等倍のまま）。
		if ( rot !== 0 || scl !== 1 ) {
			const cx = ( vw / 2 ).toFixed( 1 ), cy = ( vh / 2 ).toFixed( 1 );
			path.setAttribute(
				'transform',
				`translate(${ cx } ${ cy }) rotate(${ rot.toFixed( 2 ) }) scale(${ scl.toFixed( 4 ) }) translate(${ ( -vw / 2 ).toFixed( 1 ) } ${ ( -vh / 2 ).toFixed( 1 ) })`
			);
		} else {
			path.removeAttribute( 'transform' );
		}

		// stage 全体（水＋ラベル）は平行移動のみ。
		stage.style.transform = `translate(${ zpx( tx ) }, ${ zpx( ty ) })`;

		// 三角ラベル用の pin 接近度。graphic は sticky top:0 なので、pin 前は rect.top > 0、
		// pin 後は 0。残り距離が LABEL0_PIN_LEAD → 0 に縮む間に 0→1 でフェードインする。
		// rect は実px なので ÷Z でデザイン空間へ（しきい値もデザインpx）。
		const pinIn = smoothstep(
			LABEL0_PIN_LEAD, 0, graphic.getBoundingClientRect().top / Z
		);
		labelEls.forEach( ( el, m ) => {
			if ( el ) el.style.opacity = labelOpacity( m, fi, pinIn ).toFixed( 3 );
		} );

		// Experience：内側(動画＋テキスト)を「通常フロー位置」へ translateY。
		//   translateY = experienceScroll(フロー上端) − experienceWindow(sticky現在上端)。
		//   → 内側は常にフロー位置に見え、固定窓(overflow:hidden)が上下端でネイティブにクリップ＝ラグ無し。
		if ( expScroll && expWindow && expInner ) {
			// rect はデザイン空間へ揃え、書き込み時に zpx() で実px へ戻す（＝実px の差そのもの）。
			const sTop = expScroll.getBoundingClientRect().top / Z;
			const wTop = expWindow.getBoundingClientRect().top / Z;
			expInner.style.transform = `translateY(${ zpx( sTop - wTop ) })`;
			// フェード（位置基準）：動画・テキストとも「窓の中央の少し下で opacity=1」＝中央では完全に不透明。
			// 各要素の中心が 窓下端→窓の55%地点 に上がる間に 0→1。
			const win = anchors[ 2 ].rect;
			// ★ 四角の完成をゲートに掛ける。
			// 位置基準のフェードは形状の進捗を見ていないため、モーフ中（まだ丸みのある形）でも
			// 中身がフェードインし始めてしまう。1440 では両者のタイミングが偶然合っていたが、
			// スクロール進捗（実px の spSpan）とレイアウト位置（デザイン空間）は別の量なので、
			// zoom で縮小すると decouple してズレが表に出る。
			//
			// fi は 0..2。円→四角の区間が seg=1 なので fi-1 がその区間の進捗 lt。
			// 形状は morphT = smoothstep(0.50, 0.92, lt) で lt=0.92 に完成するため、そこをゲートにする。
			// fi >= 2（四角を保持）では fi-1 = 1 なので常に 1 ＝ 従来と同じ挙動になる。
			// 掛け算なので「遅らせる方向」にしか効かない（早くなることはない）。
			// 円ラベルの enterOpacity() が形状完成でゲートしているのと同じ手口。
			//
			// 閾値 0.88 / 0.94 は暫定。狭いと開いた瞬間に一気に濃くなる（ポップして見える）ので、
			// その場合は 0.86 / 1.00 のように広げて調整する。
			const rectGate = smoothstep( 0.88, 0.94, fi - 1 );
			// 2026-08-27 の指摘: 「四角のフェードインから動画が出現するまでのスクロール量が多い」。
			// 入場開始（ガーター）は四角の完成に合わせたまま動かさない
			// ＝ 動かすと「完成前にフェードインする」不具合が復活するため。
			// 代わりにフェードの範囲を下へずらして、早く見え始めるようにする。
			//   旧: 中心が 窓下端(1.0) → 窓の 55% に上がる間に 0→1
			//   新: 中心が 窓下端の少し下(1.25) → 窓の 75% に上がる間に 0→1
			// 開始を窓の下（クリップされている領域）から始めるので、せり上がりながら濃くなる。
			// ※動画（モーション正典）の「窓の中央の少し下で opacity=1」から意図的に外れる。指摘による。
			const FADE_FROM = 1.25;
			const FADE_TO = 0.75;
			const fadeAt = ( el ) => {
				const r = rectZ( el );        // win がデザイン空間なので rect も揃える
				const c = r.top + r.height / 2;
				return (
					smoothstep( win.y + win.h * FADE_FROM, win.y + win.h * FADE_TO, c ) * rectGate
				).toFixed( 3 );
			};
			if ( mediaFigure ) mediaFigure.style.opacity = fadeAt( mediaFigure );
			if ( expBody ) expBody.style.opacity = fadeAt( expBody );
		}

		// -------- Products & Solutions morph（水rectが右から縮む→箱が定位置に決まってから中身を出す。水rectは残す）--------
		// 動画: f_0348〜0361 で水rectが右から左メディア箱へ縮む。f_0361〜0369 で右カラムのテキストが先行 fade in。
		//        f_0369〜0377 で製品ビジュアルが「箱の定位置」で現れる（＝下から上がらない）。
		//        ※動画の6枚グリッドは旧デザイン。追従せず現行の 3枚スライダー(splide)が正。
		if ( productsMedia ) {
			// m は toBox / mc に使う＝すべてデザイン空間。vh との比較もデザイン空間で揃う。
			const m = rectZ( productsMedia );
			const mcRaw = m.top + m.height / 2;
			// mc はネイティブの実位置をそのまま使う（平滑スクロール基準にすると水rectの上昇が
			// テキストより遅れて「ディレイ」に見えるため。テキストと同一基準にするのが正）。
			const mc = mcRaw;
			// 2026-08-27（指摘 8 回目）: 掃引の開始側だけを 0.98vh → 1.20vh に広げた。
			//   指摘 a「左への移動が急」→ 掃引の尺 0.48vh(389px) → 0.70vh(567px)。+46% ゆるやかに。
			//   指摘 b「中身が出きった後、四角が固定されている区間のスクロール量が多い」
			//        → 掃引の開始が早まるぶん固定区間が縮む（約 306px → 約 128px）。
			//   着地側 0.50vh は動かさない（＝メディア箱に収まる位置は動画実測）。
			//   安全条件: 掃引開始が「中身が窓から抜け切る位置（pin 終わり 3841px）」より後であること。
			//     掃引開始 = productsMedia の中心 doc位置 − 1.20vh なので、
			//     productsMedia の高さが 120px 以上あれば成立する（実寸は約 377px）。
			//   pp のしきい値（テキスト 0.6 / スライダー 0.45）は掃引に対する割合なので変更しない
			//   ※2026-08-27（指摘 10 回目）で着地側を productsLandCenter（= vh/2 + 48px）へ変更。
			//     掃引の両端が同じだけ下がるので尺 0.70vh は不変。開始も 48px 手前になるため、
			//     上の安全条件は「productsMedia の高さが 214px 以上」に変わる（実寸 618px）。
			//   （動画 f_0348〜0361 の掃引中に f_0357 でテキスト＝中〜後半、という関係が保たれる）。
			const landC = productsLandCenter( m.height );
			const pp = smoothstep( landC + vh * PRODUCTS_SWEEP, landC, mc );      // 水平掃引の進捗: 全幅rect→左メディア箱

			// reveal は CSS transition に委譲（per-frame の opacity 書き込みはしない）。動画(f_0357〜)準拠:
			//  ・テキスト: 掃引に合わせて下からスライドアップ＋fade（pp>0.35）。
			//  ・製品スライダー: 掃引中に fade in（pp>0.45）。位置は下記ピンで水rectに一致（＝下から上がらない）。
			if ( productsSection ) productsSection.classList.toggle( 'is-products-revealed', pp > 0.6 );   // 動画: 掃引の中〜後半(f_0357〜)でテキスト出現
			// スライダー層の出現（掃引中に fade in）。位置は rebuild 固定＋水ステージ transform に追従＝水rectとロック。
			if ( productsLayer ) productsLayer.classList.toggle( 'is-in', pp > 0.45 );

			if ( pp > 0.0005 ) {
				// from = Experience 全幅rect, to = productsBg 位置の左メディア箱（中心=vh/2 / 右端=画面中央 / 左は画面外へフラッシュ）。
				const from = anchors[ 2 ].rect;
				const BLEED = 1280;                       // 箱幅（右角丸 ~32px かつ左端を画面外＝フラッシュ）
				const toBox = { x: m.right - BLEED, y: landC - m.height / 2, w: BLEED, h: m.height };
				const box = {
					x: lerp( from.x, toBox.x, pp ),
					y: lerp( from.y, toBox.y, pp ),
					w: lerp( from.w, toBox.w, pp ),
					h: lerp( from.h, toBox.h, pp ),
				};
				// 背景固定：stage は Experience終端の offset を維持し、clip を stage ローカル(box − offset)で縮める。
				// 着地後(mc<vh/2)は followY 分 stage を上へ動かし、水をスライダーに追従＝クロスフェードの位置ズレを防ぐ。
				const off = anchors[ 2 ].offset;
				const followY = Math.max( 0, landC - mc );
				// gTop = graphic の実際の画面Y。off/box は「graphic が top:0 に pin されている」前提の
				// 画面座標なので、pin が切れた後（＝morph コンテナ下端に達した後）はこの分ずれる。
				// 毎フレーム引き算して打ち消す＝pin の有無に依存せず box の画面位置が常に正しくなる。
				// これにより Products セクションに pin 維持用の余剰スクロール(min-height)が不要になる。
				// stage.transform に混ぜるのでデザイン空間へ揃える。
				const gTop = graphic.getBoundingClientRect().top / Z;
				const bl = { x: box.x - off.x, y: box.y - off.y, w: box.w, h: box.h };
				path.removeAttribute( 'transform' );
				path.setAttribute( 'd', toPath( fitTokens( CLIENT_PATHS.rect, CLIENT_BBOX.rect, bl ) ) );
				stage.style.transform = `translate(${ zpx( off.x ) }, ${ zpx( off.y - followY - gTop ) })`;
				// 水（img03）をクリップに随伴させる。この区間は clip 側が stage ローカルで動くため、
				// 背景を「クリップ箱の中心」に合わせて同じだけ動かす＝他ストップと同じ見え方になる。
				// stage の transform は変更しない（スライダーは stage の子でロック済みのため崩さない）。
				const bgX = ( bl.x + bl.w / 2 ) - vw / 2;
				const bgY = ( bl.y + bl.h / 2 ) - vh / 2;
				water.style.backgroundPosition =
					`calc(50% + ${ zpx( bgX ) }) calc(50% + ${ zpx( bgY ) })`;
				const pblur = 2.0 * Math.sin( Math.PI * clamp( pp, 0, 1 ) );
				water.style.filter = pblur > 0.1 ? `blur(${ zpx( pblur, 2 ) })` : 'none';
			}
		}

	}

	rebuild();
	let target = readSp();
	window.addEventListener( 'resize', () => { rebuild(); target = readSp(); } );
	window.addEventListener( 'scroll', () => { target = readSp(); }, { passive: true } );
	smooth = target;
	smoothScroll = window.scrollY;
	( function loop() {
		requestAnimationFrame( loop );
		smooth += ( target - smooth ) * 0.12;
		smoothScroll += ( window.scrollY - smoothScroll ) * 0.12;   // 段階的スクロールを平滑化
		render( smooth );
	} )();
}
